import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import styles from './SimpleButton.module.scss';

const SimpleButton = ({children, className, anchor, onClick, disabled = false, ...props}) => {
    if (anchor) {
        return (
            <a
                className={classnames(styles.simpleBtn, {[className]: className})}
                href={`#${anchor}`}
                onClick={onClick}
                {...props}
            >
                {children}
            </a>
        );
    }

    return (
        <button
            disabled={disabled}
            className={classnames(styles.simpleBtn, {[className]: className})}
            onClick={onClick}
            {...props}
        >
            {children}
        </button>
    );
};

SimpleButton.propTypes = {
    children: PropTypes.any,
    anchor: PropTypes.string,
    className: PropTypes.string,
    onClick: PropTypes.func,
};

SimpleButton.defaultProps = {
    children: null,
    anchor: null,
    className: null,
    onClick: null,
};

export default React.memo(SimpleButton);
